import React, { Component } from 'react';
import { withRouter } from 'react-router';
import {
    SkeletonDisplayText,
    SkeletonBodyText,
    SkeletonThumbnail,
    Page,
    Layout,
    Card,
    FormLayout,
    Spinner,
    BlockStack,
    Icon,
    Text,
    FullscreenBar,
    Popover,
    // ButtonGroup,
    // Button,
    Badge,
    InlineGrid,

} from '@shopify/polaris';
import { CaretDownIcon } from "@shopify/polaris-icons";
import './index.scss';
import ImageOptimizationSettingsIcon from '../../assets/ImageOptimizationSettingsIcon'
import ImageAltTextSettingsIcon from '../../assets/ImageAltTextSettingsIcon'
import ImageFilenameSettingsIcon from '../../assets/ImageFilenameSettingsIcon'
import Switch from "react-switch";
import { store } from '../../redux/store';


import Language from '../../i18n/Language';
import utils from '../../utils/utils';
import FooterTrustHelp from '../FooterTrustHelp';
const t = Language

class SkeltonLoading extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loadingLength: 3,
            ApploadingLength: 13,
            appHtml: [],

            isShowQuotaPro: true,   // onpage  额度banner状态
            isShowQuotaImage: true, // 图片压缩 额度banner状态
        };
    }

    UNSAFE_componentWillMount() {
        let quotaBannerPro = null;
        let quotaBannerImage = null;
        try {
            quotaBannerPro = sessionStorage.getItem('quotaBannerPro')
        } catch (e) {
            quotaBannerPro = 0;
        }
        try {
            quotaBannerImage = sessionStorage.getItem('quotaBannerPro')
        } catch (e) {
            quotaBannerImage = 0;
        }
        this.setState({
            isShowQuotaPro: Boolean(Number(quotaBannerPro)),
            isShowQuotaImage: Boolean(Number(quotaBannerImage)),
        })
    }

    render() {
        const shopify = window.shopify; // shopify 内嵌参数

        let contentRes = null; // 骨架屏
        let titleRes = "SEOWILL"; // 页面标题
        let isShowTitle = false; // 是否展示标题 默认true
        let isFullWidth = false; // 是否全屏 默认false
        let isShowFooter = true; // 是否展示footer
        let isFullscreen = ''; // 全屏对象
        let isDiyLayout = false; // 是否自定义布局

        const title = (icon, title, switchText = '', state = false, isShowIcon = true) => {
            return <div className='optimizeImagestTitle'>
                {isShowIcon ? <Icon source={icon} /> : null}
                <span>{title}</span>
                {Boolean(switchText) ? <Switch onChange={() => this.handleSwitchChange(switchText)} checked={state} height={20} width={32} uncheckedIcon={false} checkedIcon={false} onColor="#303030" offColor="#888888" /> : null}
            </div>
        }

        //首页
        const Dashboard = <BlockStack gap={400}>
            <Layout>
                <Layout.Section>
                    <SkeletonBodyText lines={1} />
                </Layout.Section>
                <br />
                <Layout.Section>
                    <Card>
                        <BlockStack gap={400}>
                            <SkeletonBodyText />
                            <SkeletonBodyText lines={2} />
                        </BlockStack>
                    </Card>
                </Layout.Section>
            </Layout>
            <Layout>
                <Layout.Section variant='oneHalf'>
                    <Card>
                        <BlockStack gap={400}>
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                        </BlockStack>
                    </Card>
                </Layout.Section>
                <Layout.Section variant='oneHalf'>
                    <Card>
                        <BlockStack gap={400}>
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                        </BlockStack>
                    </Card>
                </Layout.Section>
            </Layout>
            <Layout>
                <Layout.Section>
                    <BlockStack gap={400}>
                        <Card>
                            <BlockStack gap={400}>
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                            </BlockStack>
                        </Card>
                        <Card>
                            <BlockStack gap={400}>
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                            </BlockStack>
                        </Card>
                        <Card>
                            <BlockStack gap={400}>
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                            </BlockStack>
                        </Card>
                        <Card>
                            <BlockStack gap={400}>
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                            </BlockStack>
                        </Card>
                        <Card>
                            <BlockStack gap={400}>
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                            </BlockStack>
                        </Card>
                    </BlockStack>
                </Layout.Section>
            </Layout>
        </BlockStack>;

        //SEO Checker 检测页面
        const WebsiteCCheck = <div>
            <div className="class-layout-right">
                <Layout>
                    <Layout.Section>
                        <Card>
                            <FormLayout>
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                            </FormLayout>
                        </Card>
                    </Layout.Section>
                    <Layout.Section>
                        <Card>
                            <FormLayout>
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText lines={2} />
                            </FormLayout>
                        </Card>
                    </Layout.Section>
                    <Layout.Section>
                        <Card>
                            <FormLayout>
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText lines={2} />
                            </FormLayout>
                        </Card>
                    </Layout.Section>
                </Layout>

            </div>
        </div>;

        //分数检测服务页面
        const SeoExpertServices = <BlockStack gap={400}>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText lines={2} />
                </BlockStack>
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
        </BlockStack>;

        //批量操作页面
        const ManualBulkEdit = <div>
            <BlockStack gap={400}>
                <Card>
                    <FormLayout>
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                    </FormLayout>
                </Card>
                <Card>
                    <FormLayout>
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                    </FormLayout>
                </Card>
                <Card>
                    <FormLayout>
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                    </FormLayout>
                </Card>
                <SkeletonDisplayText size="medium" />
                <Card>
                    <FormLayout>
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                    </FormLayout>
                </Card>
                <Card>
                    <FormLayout>
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                    </FormLayout>
                </Card>
            </BlockStack>
        </div>

        // 新图片压缩
        const PageSpeedNew = <div>
            <div className='Image_Opt_Info'>
                <BlockStack gap={400}>
                    <div className='TopDataBlock'>
                        <Card padding={300}>
                            <BlockStack gap={500}>
                                <SkeletonDisplayText size="medium" />
                                <SkeletonBodyText lines={2} />
                            </BlockStack>
                        </Card>
                        <Card padding={300}>
                            <BlockStack gap={500}>
                                <SkeletonDisplayText size="medium" />
                                <SkeletonBodyText lines={2} />
                            </BlockStack>
                        </Card>
                        <Card padding={300}>
                            <BlockStack gap={500}>
                                <SkeletonDisplayText size="medium" />
                                <SkeletonBodyText lines={2} />
                            </BlockStack>
                        </Card>
                    </div>
                    <Card>
                        <BlockStack gap={500}>
                            <SkeletonDisplayText size="medium" />
                            <SkeletonBodyText lines={2} />
                            <SkeletonBodyText lines={2} />
                            <SkeletonBodyText lines={2} />
                        </BlockStack>
                    </Card>
                    <Card>
                        <BlockStack gap={500}>
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText lines={2} />
                            <SkeletonBodyText lines={2} />
                        </BlockStack>
                    </Card>
                    <Card>
                        <BlockStack gap={500}>
                            <SkeletonDisplayText size="medium" />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText lines={2} />
                        </BlockStack>
                    </Card>
                    <Card>
                        <BlockStack gap={500}>
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                        </BlockStack>
                    </Card>
                </BlockStack>
            </div>

        </div>

        //图片压缩详情页面
        const ImageModuleDetails = <Card>
            <BlockStack gap={400}>
                <SkeletonDisplayText />
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </BlockStack>
        </Card>;

        //图片压缩页面
        const PageSpeedSetting = <div className="">
            <Layout>
                <Layout.Section>
                    <BlockStack gap={400}>
                        <Card>
                            <FormLayout>
                                <Text variant="headingLg" as="h5">{title(null, t("Select optimization mode"), '', false, false)}</Text>
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                            </FormLayout>
                        </Card>
                        <Card>
                            <FormLayout>
                                <Text variant="headingLg" as="h5">{title(ImageOptimizationSettingsIcon, t("Optimize Images"), '')}</Text>
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                            </FormLayout>
                        </Card>
                        <Card>
                            <FormLayout>
                                <Text variant="headingLg" as="h5">{title(ImageAltTextSettingsIcon, t("Image Alt Text"), '')}</Text>
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                            </FormLayout>
                        </Card>
                        <Card>
                            <FormLayout>
                                <Text variant="headingLg" as="h5">{title(ImageFilenameSettingsIcon, t("Image Filename"), '')}</Text>
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                            </FormLayout>
                        </Card>
                    </BlockStack>
                </Layout.Section>
            </Layout>
        </div>;

        //On page 操作页面
        const OnPageSeo = <BlockStack gap={400}>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText lines={2} />
                    <SkeletonBodyText lines={2} />
                </BlockStack>
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText lines={2} />
                    <SkeletonBodyText lines={2} />
                </BlockStack>
            </Card>
            {/* <div className='onpage_data_block loading_onpage'>
                <Card>
                    <BlockStack gap={300}>
                        <SkeletonDisplayText size="medium" />
                        <SkeletonBodyText lines={1} />
                    </BlockStack>
                </Card>
                <Card>
                    <BlockStack gap={300}>
                        <SkeletonDisplayText size="medium" />
                        <SkeletonBodyText lines={1} />
                    </BlockStack>
                </Card>
                <Card>
                    <BlockStack gap={300}>
                        <SkeletonDisplayText size="medium" />
                        <SkeletonBodyText lines={1} />
                    </BlockStack>
                </Card>
                <Card>
                    <BlockStack gap={300}>
                        <SkeletonDisplayText size="medium" />
                        <SkeletonBodyText lines={1} />
                    </BlockStack>
                </Card>
            </div> */}
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
        </BlockStack>;
        // onpage 详情页面
        const OnPageSeoDetail = <div>
            <Layout>
                <Layout.Section>
                    <BlockStack gap={400}>
                        <Card>
                            <BlockStack gap={400}>
                                <SkeletonDisplayText size="medium" />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                            </BlockStack>
                        </Card>
                        <Card>
                            <BlockStack gap={400}>
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                            </BlockStack>
                        </Card>
                        <Card>
                            <BlockStack gap={400}>
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText lines={2} />
                                <SkeletonBodyText lines={2} />
                            </BlockStack>
                        </Card>
                        <Card>
                            <BlockStack gap={400}>
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                            </BlockStack>
                        </Card>
                    </BlockStack>
                </Layout.Section>
                <Layout.Section variant='oneThird'>
                    <BlockStack gap={400}>
                        <Card>
                            <BlockStack gap={400}>
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                            </BlockStack>
                        </Card>
                        <Card>
                            <BlockStack gap={400}>
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                            </BlockStack>
                        </Card>
                        <Card>
                            <BlockStack gap={400}>
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                            </BlockStack>
                        </Card>
                    </BlockStack>
                </Layout.Section>
            </Layout>
        </div>

        // // 生成博客页面
        // const GenerateBlogPage = <div>
        //     <BlockStack gap={400}>
        //         <SkeletonBodyText />
        //         <Card>
        //             <BlockStack gap={400}>
        //                 <SkeletonDisplayText />
        //                 <SkeletonBodyText />
        //                 <SkeletonBodyText />
        //                 <SkeletonBodyText />
        //                 <SkeletonBodyText />
        //                 <SkeletonBodyText />
        //                 <SkeletonBodyText />
        //             </BlockStack>
        //         </Card>
        //     </BlockStack>
        // </div>

        // 生成博客进度页面
        const GenerateProgress = <div>
            <BlockStack gap={400}>
                <Card>
                    <div className='generate_progress_loading'>
                        <BlockStack gap={400}>
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                        </BlockStack>
                        <BlockStack gap={400}>
                            <SkeletonDisplayText size="medium" />
                            <SkeletonBodyText />
                            <SkeletonBodyText lines={2} />
                            <SkeletonBodyText lines={2} />
                        </BlockStack>
                    </div>
                </Card>
            </BlockStack>
        </div>

        //404 broken link 页面
        const BrokenLink = <BlockStack gap={400}>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText lines={2} />
                    <SkeletonBodyText lines={2} />
                </BlockStack>
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonDisplayText size="medium" />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
        </BlockStack>;

        //HTML Sitemap 页面
        const HtmlSitemap = <Layout>
            <Layout.Section>
                <Card>
                    <SkeletonDisplayText size="medium" />
                    <br />
                    <FormLayout>
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText lines={2} />
                    </FormLayout>
                </Card>
            </Layout.Section>
            <Layout.Section>
                <Card>
                    <FormLayout>
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                    </FormLayout>
                </Card>
            </Layout.Section>
        </Layout>;

        //外链互换页面
        const ExchangeBacklink = <Layout>
            <Layout.Section>
                <Card>
                    <BlockStack gap={400}>
                        <SkeletonBodyText />
                        <SkeletonBodyText lines={2} />
                    </BlockStack>
                </Card>
            </Layout.Section>
            <Layout.Section>
                <InlineGrid columns={4} gap="400">
                    <Card>
                        <BlockStack gap={300}>
                            <SkeletonDisplayText size="medium" />
                            <SkeletonBodyText lines={2} />
                        </BlockStack>
                    </Card>
                    <Card>
                        <BlockStack gap={300}>
                            <SkeletonDisplayText size="medium" />
                            <SkeletonBodyText lines={2} />
                        </BlockStack>
                    </Card>
                    <Card>
                        <BlockStack gap={300}>
                            <SkeletonDisplayText size="medium" />
                            <SkeletonBodyText lines={2} />
                        </BlockStack>
                    </Card>
                    <Card>
                        <BlockStack gap={300}>
                            <SkeletonDisplayText size="medium" />
                            <SkeletonBodyText lines={2} />
                        </BlockStack>
                    </Card>
                </InlineGrid>
            </Layout.Section>
            <Layout.Section>
                <Card>
                    <BlockStack gap={400}>
                        <SkeletonDisplayText size="medium" />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText lines={2} />
                    </BlockStack>
                </Card>
            </Layout.Section>
            <Layout.Section>
                <Card>
                    <BlockStack gap={400}>
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText lines={2} />
                    </BlockStack>
                </Card>
            </Layout.Section>
            <Layout.Section>
                <Card>
                    <BlockStack gap={400}>
                        <SkeletonDisplayText size="medium" />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                    </BlockStack>
                </Card>
            </Layout.Section>
            <Layout.Section>
                <Card>
                    <BlockStack gap={400}>
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                    </BlockStack>
                </Card>
            </Layout.Section>
        </Layout>;

        // 外链审计页面
        const BacklinkAudit = <BlockStack gap={400}>
            <Card>
                <SkeletonBodyText lines={2} />
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText lines={2} />
                </BlockStack>
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText lines={2} />
                </BlockStack>
            </Card>
        </BlockStack>

        //AMP 页面
        const SEOWILLAmp = <Layout>
            <Layout.Section>
                <Card>
                    <BlockStack gap={400}>
                        <SkeletonBodyText />
                        <SkeletonBodyText lines={2} />
                    </BlockStack>
                </Card>
            </Layout.Section>
            <Layout.Section>
                <BlockStack gap={400}>
                    <Card>
                        <BlockStack gap={400}>
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                        </BlockStack>
                    </Card>
                    <Card>
                        <BlockStack gap={400}>
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                        </BlockStack>
                    </Card>
                    <Card>
                        <BlockStack gap={400}>
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                        </BlockStack>
                    </Card>
                </BlockStack>
            </Layout.Section>
        </Layout>;

        // AMP 设置页面
        // 问题icon
        // const issueIcon = <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        //     <path fillRule="evenodd" clipRule="evenodd" d="M10 0C4.486 0 0 4.486 0 10C0 11.728 0.45 13.42 1.304 14.924L0.101 17.965C-0.357 19.174 0.827 20.358 2.036 19.899L5.076 18.695C6.576 19.55 8.273 20 10 20C15.514 20 20 15.514 20 10C20 4.486 15.514 0 10 0ZM5.293 9.293C5.48 9.105 5.735 9 6 9C6.265 9 6.52 9.105 6.707 9.293C6.895 9.48 7 9.735 7 10C7 10.265 6.895 10.52 6.707 10.707C6.52 10.895 6.265 11 6 11C5.735 11 5.48 10.895 5.293 10.707C5.105 10.52 5 10.265 5 10C5 9.735 5.105 9.48 5.293 9.293ZM9.293 9.293C9.48 9.105 9.735 9 10 9C10.265 9 10.52 9.105 10.707 9.293C10.895 9.48 11 9.735 11 10C11 10.265 10.895 10.52 10.707 10.707C10.519 10.894 10.265 11 10 11C9.735 11 9.48 10.895 9.293 10.707C9.106 10.519 9 10.265 9 10C9 9.735 9.105 9.48 9.293 9.293ZM14 9C13.735 9 13.48 9.105 13.293 9.293C13.105 9.48 13 9.735 13 10C13 10.265 13.105 10.52 13.293 10.707C13.481 10.894 13.735 11 14 11C14.265 11 14.52 10.895 14.707 10.707C14.894 10.519 15 10.265 15 10C15 9.735 14.895 9.48 14.707 9.293C14.52 9.105 14.265 9 14 9Z" fill="#005BD3" />
        // </svg>
        const SEOWILLAmpCustome = <div className='amp_custome_view'>
            <BlockStack gap={400}>
                <SkeletonBodyText lines={3} />
                <SkeletonBodyText lines={3} />
                <SkeletonBodyText lines={3} />
                <SkeletonBodyText lines={3} />
                <SkeletonBodyText lines={3} />
            </BlockStack>
        </div>

        // Json LD 页面
        const StructuredData = <div className='skelton_jsonid'>
            <Layout>
                <Layout.Section variant="fullWidth">
                    <BlockStack gap={400}>
                        <Card>
                            <BlockStack gap={400}>
                                <SkeletonBodyText />
                                <SkeletonBodyText lines={2} />
                            </BlockStack>
                        </Card>
                    </BlockStack>
                </Layout.Section>
                <Layout.Section variant="oneThird">
                    <Card>
                        <BlockStack gap={400}>
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                        </BlockStack>
                    </Card>
                </Layout.Section>
                <Layout.Section variant="oneThird">
                    <Card>
                        <BlockStack gap={400}>
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                        </BlockStack>
                    </Card>
                </Layout.Section>
                <Layout.Section variant="oneThird">
                    <Card>
                        <BlockStack gap={400}>
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                        </BlockStack>
                    </Card>
                </Layout.Section>
                <Layout.Section variant="oneThird">
                    <Card>
                        <BlockStack gap={400}>
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                        </BlockStack>
                    </Card>
                </Layout.Section>
                <Layout.Section variant="oneThird">
                    <Card>
                        <BlockStack gap={400}>
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                        </BlockStack>
                    </Card>
                </Layout.Section>
                <Layout.Section variant="oneThird">
                    <Card>
                        <BlockStack gap={400}>
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                        </BlockStack>
                    </Card>
                </Layout.Section>
            </Layout>

        </div>;

        // 及时索引
        const InstantIndex = <BlockStack gap={400}>
            <SkeletonDisplayText size="medium" />
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
        </BlockStack>

        // LocalBusiness
        const LocalBusiness = <BlockStack gap={400}>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
        </BlockStack>

        // 关键词规划
        const KeywordPlannerDetail = <BlockStack gap={400}>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText lines={2} />
                    <SkeletonBodyText lines={2} />
                    <SkeletonBodyText lines={2} />
                </BlockStack>
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonDisplayText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
        </BlockStack>

        //竞品关键词分析页面
        const CompetitorKeywordsDetail = null;

        // 我的网站关键词
        const MyWebsiteKeywords = <BlockStack gap={400}>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonDisplayText size="medium" />
                    <SkeletonBodyText lines={2} />
                    <SkeletonBodyText lines={2} />
                </BlockStack>
            </Card>
            <div className='mywebsite_dataview'>
                <Card>
                    <BlockStack gap={400}>
                        <SkeletonDisplayText size="medium" />
                        <SkeletonBodyText lines={2} />
                    </BlockStack>
                </Card>
                <Card>
                    <BlockStack gap={400}>
                        <SkeletonDisplayText size="medium" />
                        <SkeletonBodyText lines={2} />
                    </BlockStack>
                </Card>
                <Card>
                    <BlockStack gap={400}>
                        <SkeletonDisplayText size="medium" />
                        <SkeletonBodyText lines={2} />
                    </BlockStack>
                </Card>
                <Card>
                    <BlockStack gap={400}>
                        <SkeletonDisplayText size="medium" />
                        <SkeletonBodyText lines={2} />
                    </BlockStack>
                </Card>
            </div>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonDisplayText size="medium" />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonDisplayText size="medium" />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
        </BlockStack>

        // 关键词数据
        const KeywordsData = <BlockStack gap={400}>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
        </BlockStack>

        // 关键词搜索
        const KeywordsSearch = <BlockStack gap={400}>
            <Card>
                <SkeletonBodyText lines={2} />
            </Card>
            <Card>
                <SkeletonBodyText lines={1} />
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonDisplayText size="medium" />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
        </BlockStack>

        // 关键词竞争监听
        const CompetitiveKeywordMonitoring = <BlockStack gap={400}>
            {/* <Card>
                <SkeletonBodyText lines={2} />
            </Card>
            <Card>
                <SkeletonBodyText lines={1} />
            </Card> */}
            <Card>
                <BlockStack gap={400}>
                    <SkeletonDisplayText size="medium" />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
        </BlockStack>

        // 关键词对比
        const KeywordsGap = <BlockStack gap={400}>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
        </BlockStack>

        //google流量分析页面
        const GoogleSearchConsoleV2 = <div>
            <Layout>
                <Layout.Section>
                    <Card>
                        <SkeletonBodyText />
                        <br />
                        <SkeletonBodyText />
                    </Card>
                </Layout.Section>
                <Layout.Section>
                    <Card>
                        <SkeletonDisplayText size="medium" />
                        <br />
                        <FormLayout>
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                        </FormLayout>
                        <br />
                        <SkeletonDisplayText size="medium" />
                        <br />
                        <FormLayout>
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                        </FormLayout>
                    </Card>
                </Layout.Section>
            </Layout>
        </div>

        // 旧版价格页面
        const OldPricing = <Layout>
            <Layout.Section>
                <SkeletonBodyText lines={2} />
            </Layout.Section>
            <Layout.Section>
                <div className='pricingLoading'>
                    <div className="pricingContent">
                        <div className="Polaris-Layout">
                            <div className="Polaris-Layout__Section Polaris-Layout__Section--oneThird">
                                <Card>
                                    <div className="Polaris-Card__Section">
                                        <div style={{ width: "100%" }}></div>
                                        <div className="bigspace"></div>
                                        <section className="centerAlign">
                                            <div style={{ paddingTop: '1rem' }}>
                                                <div className="SkeletonThumbnailCenter"><SkeletonThumbnail size="medium" /></div>
                                            </div>
                                            <div style={{ paddingTop: '3rem' }}>
                                                <div className="SkeletonThumbnailCenter"><SkeletonDisplayText /></div>
                                            </div>
                                        </section>
                                        <div style={{ color: "#343434", fontSize: "13px", margin: "23px 0", textAlign: "center" }} >
                                        </div>
                                        <div className="pricingList">
                                            <table style={{ borderCollapse: 'collapse', width: '100%', whiteSpace: 'nowrap' }}>
                                                <thead></thead>
                                                <tbody>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </Card>
                            </div>

                            <div className="Polaris-Layout__Section Polaris-Layout__Section--oneThird pricingCard" >
                                <Card>
                                    <div className="Polaris-Card__Section">
                                        <div style={{ width: "100%" }}></div>
                                        <div className="bigspace"></div>
                                        <section className="centerAlign">
                                            <div style={{ paddingTop: '1rem' }}>
                                                <div className="SkeletonThumbnailCenter"><SkeletonThumbnail size="medium" /></div>
                                            </div>
                                            <div style={{ paddingTop: '3rem' }}>
                                                <div className="SkeletonThumbnailCenter"><SkeletonDisplayText /></div>
                                            </div>
                                        </section>
                                        <div style={{ color: "#343434", fontSize: "13px", margin: "23px 0", textAlign: "center" }} >
                                        </div>
                                        <div className="pricingList">
                                            <table style={{ borderCollapse: 'collapse', width: '100%', whiteSpace: 'nowrap' }}>
                                                <thead></thead>
                                                <tbody>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </Card>
                            </div>
                            <div className="Polaris-Layout__Section Polaris-Layout__Section--oneThird pricingCard">
                                <Card>
                                    <div className="Polaris-Card__Section">
                                        <div style={{ width: "100%" }}></div>
                                        <div className="bigspace"></div>
                                        <section className="centerAlign">
                                            <div style={{ paddingTop: '1rem' }}>
                                                <div className="SkeletonThumbnailCenter"><SkeletonThumbnail size="medium" /></div>
                                            </div>
                                            <div style={{ paddingTop: '3rem' }}>
                                                <div className="SkeletonThumbnailCenter"><SkeletonDisplayText /></div>
                                            </div>
                                        </section>
                                        <div style={{ color: "#343434", fontSize: "13px", margin: "23px 0", textAlign: "center" }} >
                                        </div>
                                        <div className="pricingList">
                                            <table style={{ borderCollapse: 'collapse', width: '100%', whiteSpace: 'nowrap' }}>
                                                <thead></thead>
                                                <tbody>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </Card>
                            </div>
                            <div className="Polaris-Layout__Section Polaris-Layout__Section--oneThird pricingCard">
                                <Card>
                                    <div className="Polaris-Card__Section">
                                        <div style={{ width: "100%" }}></div>
                                        <div className="bigspace"></div>
                                        <section className="centerAlign">
                                            <div style={{ paddingTop: '1rem' }}>
                                                <div className="SkeletonThumbnailCenter"><SkeletonThumbnail size="medium" /></div>
                                            </div>
                                            <div style={{ paddingTop: '3rem' }}>
                                                <div className="SkeletonThumbnailCenter"><SkeletonDisplayText /></div>
                                            </div>
                                        </section>
                                        <div style={{ color: "#343434", fontSize: "13px", margin: "23px 0", textAlign: "center" }} >
                                        </div>
                                        <div className="pricingList">
                                            <table style={{ borderCollapse: 'collapse', width: '100%', whiteSpace: 'nowrap' }}>
                                                <thead></thead>
                                                <tbody>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                    <tr><td><SkeletonBodyText lines={1} /></td></tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </Card>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout.Section>
        </Layout>

        // 新版价格页面
        const Pricing = <div className='pricing_loading_page'>
            <Layout>
                <Layout.Section>
                    <Card>
                        <SkeletonBodyText />
                    </Card>
                </Layout.Section>
            </Layout>
            <div className='halfspace'></div>
            <Layout>
                <Layout.Section variant='oneThird'>
                    <Card>
                        <BlockStack gap={400}>
                            <SkeletonDisplayText size="small" />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                        </BlockStack>
                    </Card>
                </Layout.Section>
                <Layout.Section variant='oneThird'>
                    <Card>
                        <BlockStack gap={400}>
                            <SkeletonDisplayText size="small" />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                        </BlockStack>
                    </Card>
                </Layout.Section>
                <Layout.Section variant='oneThird'>
                    <Card>
                        <BlockStack gap={400}>
                            <SkeletonDisplayText size="small" />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                        </BlockStack>
                    </Card>
                </Layout.Section>

            </Layout>
        </div>

        //APP 集合页面
        const FunctionIntegration = <div>
            <div className="Service_Layout_Card" style={{ marginTop: "0" }}>
                <Card>
                    <SkeletonDisplayText size="small" />
                    <br />
                    <Layout>
                        <Layout.Section variant='oneThird'>
                            <Card>
                                <BlockStack gap={500}>
                                    <SkeletonDisplayText size="small" />
                                    <SkeletonBodyText lines={2} />
                                </BlockStack>
                            </Card>
                        </Layout.Section>
                        <Layout.Section variant='oneThird'>
                            <Card>
                                <BlockStack gap={500}>
                                    <SkeletonDisplayText size="small" />
                                    <SkeletonBodyText lines={2} />
                                </BlockStack>
                            </Card>
                        </Layout.Section>
                        <Layout.Section variant='oneThird'>
                            <Card>
                                <BlockStack gap={500}>
                                    <SkeletonDisplayText size="small" />
                                    <SkeletonBodyText lines={2} />
                                </BlockStack>
                            </Card>
                        </Layout.Section>
                    </Layout>
                    <br />
                    <Layout>
                        <Layout.Section variant='oneThird'>
                            <Card>
                                <BlockStack gap={500}>
                                    <SkeletonDisplayText size="small" />
                                    <SkeletonBodyText lines={2} />
                                </BlockStack>
                            </Card>
                        </Layout.Section>
                        <Layout.Section variant='oneThird'>
                            <Card>
                                <BlockStack gap={500}>
                                    <SkeletonDisplayText size="small" />
                                    <SkeletonBodyText lines={2} />
                                </BlockStack>
                            </Card>
                        </Layout.Section>
                        <Layout.Section variant='oneThird'>
                            <Card>
                                <BlockStack gap={500}>
                                    <SkeletonDisplayText size="small" />
                                    <SkeletonBodyText lines={2} />
                                </BlockStack>
                            </Card>
                        </Layout.Section>
                    </Layout>
                </Card>
            </div>
            <div className="Service_Layout_Card" style={{ marginTop: "2rem" }}>
                <Card>
                    <SkeletonDisplayText size="small" />
                    <br />
                    <Layout>
                        <Layout.Section variant='oneThird'>
                            <Card>
                                <BlockStack gap={500}>
                                    <SkeletonDisplayText size="small" />
                                    <SkeletonBodyText />
                                </BlockStack>
                            </Card>
                        </Layout.Section>
                        <Layout.Section variant='oneThird'>
                            <Card>
                                <BlockStack gap={500}>
                                    <SkeletonDisplayText size="small" />
                                    <SkeletonBodyText />
                                </BlockStack>
                            </Card>
                        </Layout.Section>
                        <Layout.Section variant='oneThird'>
                            <Card>
                                <BlockStack gap={500}>
                                    <SkeletonDisplayText size="small" />
                                    <SkeletonBodyText />
                                </BlockStack>
                            </Card>
                        </Layout.Section>
                    </Layout>
                </Card>
            </div>
        </div>

        //问答页面
        const Feedback = <Card>
            <div className="DetailReport_Empty_New_div_margin_800">
                <Spinner size="large" color="teal" />
            </div>
        </Card>
        // <Layout>
        //     <Layout.Section>
        //         <Layout>
        //             <Layout.Section variant='oneThird'>
        //                 <Card>
        //                     <BlockStack gap={400}>
        //                         <Text variant="headingMd" as="h2">In development</Text>
        //                         <SkeletonBodyText />
        //                         <SkeletonBodyText lines={1} />
        //                     </BlockStack>
        //                 </Card>
        //             </Layout.Section>
        //             <Layout.Section variant='oneThird'>
        //                 <Card>
        //                     <BlockStack gap={400}>
        //                         <Text variant="headingMd" as="h2">New functions</Text>
        //                         <SkeletonBodyText />
        //                         <SkeletonBodyText lines={1} />
        //                     </BlockStack>
        //                 </Card>
        //             </Layout.Section>
        //         </Layout>
        //     </Layout.Section>
        //     <Layout.Section>
        //         <Layout>
        //             <Layout.Section variant='oneHalf'>

        //             </Layout.Section>
        //         </Layout>
        //     </Layout.Section>
        // </Layout>;

        // 指导手册页面
        const InstuctionManual = <div>
            <Card>
                <FormLayout>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </FormLayout>
            </Card>
        </div>

        //活动页面
        const AppActivity = <div className='Polaris-Layout__Section' style={{ maxWidth: '100%', marginLeft: '0' }}>
            <div>
                <Card>
                    <FormLayout>
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                    </FormLayout>
                </Card>
                {/* <div className="halfspace"></div>
                <Card>
                    <FormLayout>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    </FormLayout>
                </Card> */}
                <div className="halfspace"></div>
                <div className="DashboardModuleInfoV2">
                    <div style={{ width: "31%" }}>
                        <Card>
                            <SkeletonBodyText />
                            <div className="halfspace"></div>
                            <SkeletonBodyText />
                            <div className="halfspace"></div>
                            <SkeletonBodyText />
                        </Card>
                    </div>
                    <div style={{ width: "31%" }}>
                        <Card>
                            <SkeletonBodyText />
                            <div className="halfspace"></div>
                            <SkeletonBodyText />
                            <div className="halfspace"></div>
                            <SkeletonBodyText />
                        </Card>
                    </div>
                    <div style={{ width: "31%" }}>
                        <Card>
                            <SkeletonBodyText />
                            <div className="halfspace"></div>
                            <SkeletonBodyText />
                            <div className="halfspace"></div>
                            <SkeletonBodyText />
                        </Card>
                    </div>
                </div>
            </div>
        </div>

        //推荐应用页面
        const Integration = <div className='integration_page_loading'>
            <BlockStack gap={400}>
                <Card>
                    <BlockStack gap={400}>
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                    </BlockStack>
                </Card>
                <Card>
                    <BlockStack gap={400}>
                        <InlineGrid gap={400} columns={3}>
                            <Card>
                                <BlockStack gap={400}>
                                    <SkeletonBodyText />
                                    <SkeletonBodyText />
                                    <SkeletonBodyText />
                                </BlockStack>
                            </Card>
                            <Card>
                                <BlockStack gap={400}>
                                    <SkeletonBodyText />
                                    <SkeletonBodyText />
                                    <SkeletonBodyText />
                                </BlockStack>
                            </Card>
                            <Card>
                                <BlockStack gap={400}>
                                    <SkeletonBodyText />
                                    <SkeletonBodyText />
                                    <SkeletonBodyText />
                                </BlockStack>
                            </Card>
                        </InlineGrid>
                        <InlineGrid gap={400} columns={3}>
                            <Card>
                                <BlockStack gap={400}>
                                    <SkeletonBodyText />
                                    <SkeletonBodyText />
                                    <SkeletonBodyText />
                                </BlockStack>
                            </Card>
                            <Card>
                                <BlockStack gap={400}>
                                    <SkeletonBodyText />
                                    <SkeletonBodyText />
                                    <SkeletonBodyText />
                                </BlockStack>
                            </Card>
                            <Card>
                                <BlockStack gap={400}>
                                    <SkeletonBodyText />
                                    <SkeletonBodyText />
                                    <SkeletonBodyText />
                                </BlockStack>
                            </Card>
                        </InlineGrid>
                        <InlineGrid gap={400} columns={3}>
                            <Card>
                                <BlockStack gap={400}>
                                    <SkeletonBodyText />
                                    <SkeletonBodyText />
                                    <SkeletonBodyText />
                                </BlockStack>
                            </Card>
                            <Card>
                                <BlockStack gap={400}>
                                    <SkeletonBodyText />
                                    <SkeletonBodyText />
                                    <SkeletonBodyText />
                                </BlockStack>
                            </Card>
                            <Card>
                                <BlockStack gap={400}>
                                    <SkeletonBodyText />
                                    <SkeletonBodyText />
                                    <SkeletonBodyText />
                                </BlockStack>
                            </Card>
                        </InlineGrid>
                    </BlockStack>
                </Card>
            </BlockStack>
        </div>

        // instant page
        const InstantPage = <div>
            <Layout>
                <Layout.Section>
                    <Card>
                        <SkeletonBodyText />
                    </Card>
                    <div className='halfspace'></div>
                    <Card>
                        <SkeletonBodyText />
                        <div className='halfspace'></div>
                        <SkeletonBodyText lines={2} />
                    </Card>
                    <div className='halfspace'></div>
                    <Card>
                        <SkeletonBodyText />
                        <div className='halfspace'></div>
                        <SkeletonBodyText />
                        <div className='halfspace'></div>
                        <SkeletonBodyText />
                        <div className='halfspace'></div>
                        <SkeletonBodyText />
                        <div className='halfspace'></div>
                        <SkeletonBodyText />
                        <div className='halfspace'></div>
                        <SkeletonBodyText lines={2} />
                    </Card>
                </Layout.Section>
            </Layout>
        </div>

        // Site Verifications
        const SiteVerifications = <div>
            <BlockStack gap={400}>
                <Card>
                    <BlockStack gap={400}>
                        <SkeletonBodyText />
                    </BlockStack>
                </Card>
                <Card>
                    <BlockStack gap={400}>
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                    </BlockStack>
                </Card>
                <Card>
                    <BlockStack gap={400}>
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                    </BlockStack>
                </Card>
                <Card>
                    <BlockStack gap={400}>
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                    </BlockStack>
                </Card>
                <Card>
                    <BlockStack gap={400}>
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                    </BlockStack>
                </Card>
                <Card>
                    <BlockStack gap={400}>
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                    </BlockStack>
                </Card>
            </BlockStack>
        </div>

        // 设置页面
        const settingsPage = <div className='set_Select'>
            <BlockStack gap={400}>
                <div className='left_choice'>
                    <Card>
                        <BlockStack gap={400}>
                            <SkeletonBodyText lines={2} />
                        </BlockStack>
                    </Card>
                </div>
                <div className='right_content'>
                    <BlockStack gap={400}>
                        <Card>
                            <BlockStack gap={400}>
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                            </BlockStack>
                        </Card>
                        <Card>
                            <BlockStack gap={400}>
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                                <SkeletonBodyText />
                            </BlockStack>
                        </Card>
                    </BlockStack>
                </div>
            </BlockStack>
        </div>

        // 节省表格页面
        const recentImprove = <div>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
        </div>

        // 图片alt
        const imageAltText = <BlockStack gap={400}>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText lines={1} />
                    <SkeletonBodyText lines={1} />
                </BlockStack>
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
            <SkeletonDisplayText />
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
        </BlockStack>

        // 报告数据页面
        const ReportData = <BlockStack gap={400}>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText lines={2} />
                    <SkeletonBodyText lines={2} />
                </BlockStack>
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
        </BlockStack>

        // Organization 页面
        const OrganizationSet = <BlockStack gap={400}>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
        </BlockStack>

        // 引导页面
        const GuidePage = <BlockStack gap={400}>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
        </BlockStack>

        // 关键词规划页面
        const KeywordContentPlanner = <BlockStack gap={400}>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
        </BlockStack>

        // AI Blog Generator
        const AiBlogGenerator = <BlockStack gap={400}>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
        </BlockStack>

        // LLMS.TXT
        const LlmsTxt = <div className='llms_txt_loading_page'>
            <div className='llms_left'>
                <BlockStack gap={400}>
                    <Card>
                        <BlockStack gap={400}>
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                        </BlockStack>
                    </Card>
                    <Card>
                        <BlockStack gap={400}>
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                            <SkeletonBodyText />
                        </BlockStack>
                    </Card>
                </BlockStack>
            </div>
            <div className='llms_right'>
                <Card>
                    <BlockStack gap={400}>
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                    </BlockStack>
                </Card>
            </div>
        </div>

        // Product Schema
        const ProductSchema = <BlockStack gap={400}>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                    <SkeletonBodyText lines={2} />
                    <SkeletonBodyText lines={2} />
                </BlockStack>
            </Card>
            {/* <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card>
            <Card>
                <BlockStack gap={400}>
                    <SkeletonBodyText />
                    <SkeletonBodyText />
                </BlockStack>
            </Card> */}
        </BlockStack>


        const pathName = window.location.pathname; // 路由
        switch (pathName) {
            case "/dashboard":
                //首页
                isShowTitle = true;
                contentRes = Dashboard;
                titleRes = "SEOWILL - Dashboard";
                break;
            case "/website-check":
                //SEO Checker 检测页面
                isShowTitle = true;
                contentRes = WebsiteCCheck;
                titleRes = "SEOWILL - SEO Checker";
                break;
            case "/speedOpt":
            case "/speedOpt/site-speedup":
                //分数检测服务页面
                contentRes = SeoExpertServices;
                titleRes = "SEOWILL - Google PageSpeed Checker";
                break;
            case "/content-seo":
            case "/content-seo/keyword-content-planner":
                contentRes = KeywordContentPlanner;
                titleRes = "SEOWILL - AI Content Planner";
                break;
            case "/content-seo/ai-blog-generator":
                contentRes = AiBlogGenerator;
                titleRes = "SEOWILL - AI Blog Generator";
                break;
            case "/on-page-seo/bulk-edit/manual-bulk-edit":
                //批量操作页面
                isShowTitle = true;
                contentRes = ManualBulkEdit;
                titleRes = "SEOWILL - Bulk Edit";
                break;
            case "/speedOpt/PageSpeed":
                //图片压缩页面
                // contentRes = PageSpeed;
                contentRes = PageSpeedNew;
                titleRes = "SEOWILL - Image Optimization";
                break;
            case "/speedOpt/PageSpeed/details":
            case "/on-page-seo/image-alt-text/details":
            case "/keywordRearch/keywords-research/Competitor-keywords-detail":
                //图片压缩详情页面
                isShowTitle = true;
                contentRes = ImageModuleDetails;
                titleRes = "SEOWILL - Image Optimization Details";
                break;
            case "/admin/PageSpeed/setting":
                //图片压缩页面
                contentRes = PageSpeedSetting;
                titleRes = "SEOWILL - Image Optimization";
                break;
            case "/on-page-seo":
            case "/on-page-seo/list":
                //On page 操作页面
                isShowTitle = false;
                contentRes = OnPageSeo;
                titleRes = "SEOWILL - On-Page SEO Scan";
                // isFullWidth = true;
                break;
            case "/on-page-seo/detail":
                //On page 操作详情页面
                contentRes = OnPageSeoDetail;
                titleRes = "SEOWILL - Detail";
                isFullWidth = true;
                isFullscreen = 'onpage';
                isDiyLayout = true;
                break;
            case "/content-seo/ai-blog-generator/generate":
                //On page 操作详情页面
                contentRes = GenerateProgress;
                isShowTitle = true;
                titleRes = "SEOWILL - Generate Blog";
                break;
            case "/technicalSEO":
            case "/technicalSEO/broken-link/view-errors":
                //404 broken link 页面
                // contentRes = ViewErrors;
                contentRes = BrokenLink;
                titleRes = "SEOWILL - Broken Links";
                break;
            case "/backlinks/broken-link/manage-redirects":
                //404 broken link 页面
                // contentRes = ManageRedirects;
                contentRes = BrokenLink;
                titleRes = "SEOWILL - Broken Links";
                break;
            case "/backlinks/broken-link/ignore-page":
                //404 broken link 页面
                // contentRes = IgnorePage;
                contentRes = BrokenLink;
                titleRes = "SEOWILL - Broken Links";
                break;
            case "/technicalSEO/html-sitemap":
                //HTML Sitemap 页面
                isShowTitle = true;
                contentRes = HtmlSitemap;
                titleRes = "SEOWILL - HTML Sitemap";
                break;
            case "/backlinks":
            case "/backlinks/exchange-backlink":
                //外链互换页面
                contentRes = ExchangeBacklink;
                titleRes = "SEOWILL - Exchange Backlink";
                break;
            case "/backlinks/backlink-audit":
                //外链审计页面
                contentRes = BacklinkAudit;
                titleRes = "SEOWILL - Backlink Audit";
                break;
            case "/speedOpt/seo-ant-amp":
                //AMP 页面
                contentRes = SEOWILLAmp;
                titleRes = "SEOWILL - AMP";
                break;
            case "/speedOpt/seo-ant-amp/custome":
                //AMP 设置页面
                contentRes = SEOWILLAmpCustome;
                isFullscreen = 'amp_custome';
                isDiyLayout = true;
                titleRes = "SEOWILL - AMP Settings";
                break;
            case "/technicalSEO/structured-data":
                // Json LD 页面
                contentRes = StructuredData;
                titleRes = "SEOWILL - Snippets - JSON-LD";
                break;
            case "/technicalSEO/instant-index":
                // Instant index 页面
                contentRes = InstantIndex;
                titleRes = "SEOWILL - Instant Indexing";
                break;
            case "/technicalSEO/local-business":
                // Local Business 页面
                contentRes = LocalBusiness;
                titleRes = "SEOWILL - Local Business";
                isShowTitle = true;
                break;
            case "/content-seo/keyword-content-planner/detail":
                // 关键词规划详情
                contentRes = KeywordPlannerDetail;
                titleRes = "SEOWILL - Keyword Content Planner Detail";
                isShowTitle = true;
                isFullWidth = true;
                break;
            case "/keywordRearch/keywords-research/Competitor-keywords-detail":
                //竞品关键词分析页面
                contentRes = CompetitorKeywordsDetail;
                titleRes = "SEOWILL - Competitor Keywords Research";
                break;
            // case "/keywordRearch/my-website-keywords":
            //     // 我的网站关键词
            //     contentRes = MyWebsiteKeywords;
            //     titleRes = "SEOWILL - My website keywords";
            //     // isFullWidth = true;
            //     break;
            case "/keywordRearch":
            case "/keywordRearch/keywords-data":
                contentRes = KeywordsData;
                titleRes = "SEOWILL - Keyword Rank Tracker";
                break;
            case "/keywordRearch/keywords-search":
                // 关键词搜索
                contentRes = KeywordsSearch;
                titleRes = "SEOWILL - Keyword Search";
                break;
            case "/keywordRearch/keywords-monitor":
                // 竞争关键词监听
                contentRes = CompetitiveKeywordMonitoring;
                titleRes = "SEOWILL - Competitive keyword monitoring";
                // isFullWidth = true;
                break;
            case "/keywordRearch/keywords-gap":
                // 关键词对比
                contentRes = KeywordsGap;
                titleRes = "SEOWILL - Keyword Gap";
                // isFullWidth = true;
                break;
            // case "/keywordRearch/keywords-research":
            //     //竞品关键词分析页面
            //     contentRes = KeywordsLibrary;
            //     titleRes = "SEOWILL - Keywords Library";
            //     break;
            case "/keywordRearch/GoogleSearchConsoleV2":
                //google流量分析页面
                contentRes = GoogleSearchConsoleV2;
                titleRes = "SEOWILL - Google Analytics";
                break;
            case "/oldversion/pricing":
                // 旧价格页面
                contentRes = OldPricing;
                titleRes = "SEOWILL - Pricing";
                break;
            case "/plan":
                // 新价格页面
                isShowTitle = Boolean(store.getState().public.isShowTopMenu) || 1;
                contentRes = Pricing;
                titleRes = "SEOWILL - Pricing";
                break;
            case "/guide":
                // 引导页面
                contentRes = GuidePage;
                titleRes = "SEOWILL - Guide";
                break;
            case "/admin/function-integration":
                //APP 集合页面
                contentRes = FunctionIntegration
                titleRes = "SEOWILL - Reviews Integrations";
                break;
            case "/dashboard/Feedback":
                //问答页面
                contentRes = Feedback;
                titleRes = "SEOWILL - Feedback";
                isShowTitle = true;
                break;
            case "/admin/instuction-manual/index":
                //新手指引页面
                contentRes = InstuctionManual;
                titleRes = "SEOWILL - Guide";
                break;
            case "/admin/app-activity/index":
                //活动页面
                contentRes = AppActivity;
                titleRes = "SEOWILL - App Activity";
                break;
            case "/dashboard/integration":
                //推荐应用页面
                contentRes = Integration;
                titleRes = "SEOWILL - Integration";
                break;
            case "/speedOpt/instant-page":
                //Instant Page
                contentRes = InstantPage;
                titleRes = "SEOWILL - Instant Page";
                break;
            case "/technicalSEO/site-verification":
                //Site Verifications
                contentRes = SiteVerifications;
                titleRes = "SEOWILL - Site Verifications";
                break;
            case "/settings":
                isShowTitle = Boolean(store.getState().public.isShowTopMenu) || 1;
                contentRes = settingsPage;
                titleRes = "SEOWILL - Settings";
                break;
            case "/dashboard/recent-improvements":
                contentRes = recentImprove;
                titleRes = "SEOWILL - Recent Improvements";
                isShowTitle = true;
                break;
            case "/on-page-seo/image-alt-text":
                isShowTitle = true;
                contentRes = imageAltText;
                titleRes = "SEOWILL - Image alt text";
                break;
            case "/reports":
                contentRes = ReportData;
                titleRes = "SEOWILL - Report";
                isShowTitle = true;
                break;
            case "/technicalSEO/structured-data/organization":
                // Organization 页面
                contentRes = OrganizationSet;
                titleRes = "Google Structured Data - Organization";
                isShowTitle = true;
                break;
            case "/technicalSEO/llms-txt":
                contentRes = LlmsTxt;
                titleRes = "SEOWILL - llms.txt";
                isShowTitle = true;
                break;
            case "/technicalSEO/structured-data/product":
                contentRes = ProductSchema;
                titleRes = "SEOWILL - Product Schema";
                isShowTitle = true;
                break;
            default:
                break;
        }

        // 底部
        const footerHelp = <FooterTrustHelp />

        const pageMain = isDiyLayout ? <div className='Layout_Box'>
            <div className='lb_left_list'>
                <div className='lb_card' style={{ padding: '1rem' }}>
                    <BlockStack gap={400}>
                        <SkeletonDisplayText size="medium" />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                        <SkeletonBodyText />
                    </BlockStack>
                </div>
            </div>
            <div className='lb_right_main'>
                <Page
                    fullWidth={isFullWidth}
                >
                    <title>{titleRes}</title>
                    {
                        isShowTitle && <>
                            <SkeletonDisplayText />
                            <br />
                        </>
                    }
                    {contentRes}
                    {isShowFooter && footerHelp}
                </Page>
            </div>
        </div> : <Page
            fullWidth={isFullWidth}
        >
            <title>{titleRes}</title>
            {
                isShowTitle && <>
                    <SkeletonDisplayText />
                    <br />
                </>
            }
            {contentRes}
            {isShowFooter && footerHelp}
        </Page>


        return (
            <div id='SkeltonLoadingBox'>
                <div className={`top_bar_fullscreen ${shopify ? 'embeddedFull' : ''}`}>
                    {
                        isFullscreen.indexOf('onpage') > -1 && <FullscreenBar onAction={() => {
                            utils.routeJump(this, "/on-page-seo/list")
                        }}>
                            <div
                                style={{
                                    display: 'flex',
                                    flexGrow: 1,
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    paddingLeft: '1rem',
                                    paddingRight: '1rem',
                                }}
                            >
                                {/* <div className='fullscreen_top'>
                                    <img src='/imgs/svg/logo/SEOWillBlackBg.svg' alt='newlogo' />
                                    <Text variant="headingMd" as="p">{t("SEOWILL")}</Text>
                                </div> */}
                                {
                                    isFullscreen.indexOf('blog') > -1 ? <div>
                                        {t("Generate Blog post with SEOWILL AI")}
                                    </div> :
                                        <div className='flex_layout'>
                                            <Popover
                                                active={false}
                                                activator={<div className='flex_layout select_type'>
                                                    {t("Loading..")}<Icon source={CaretDownIcon} tone='base' />
                                                </div>}
                                                autofocusTarget="first-node"
                                            >
                                            </Popover>
                                            <span>&nbsp;|&nbsp;</span>
                                            <Popover
                                                active={false}
                                                activator={<div className='flex_layout select_type'>
                                                    {t("Loading..")}<Icon source={CaretDownIcon} tone='base' />
                                                </div>}
                                                autofocusTarget="sec-node"
                                            >
                                            </Popover>
                                        </div>
                                }
                                <div className='full_btn_group'>
                                    <div className='SEO_Score_face'><SkeletonBodyText lines={2} /></div>
                                    {/* <Button disabled={true}>{t("Preview")}</Button> */}
                                    {/* <ButtonGroup>
                                        <Button disabled={true}>{t("Discard")}</Button>
                                        <Button
                                            variant="primary"
                                            disabled={true}
                                        >
                                            {t("Save")}
                                        </Button>
                                    </ButtonGroup> */}
                                </div>
                            </div>
                        </FullscreenBar>
                    }
                    {
                        isFullscreen === 'amp_custome' && <FullscreenBar onAction={() => {
                            utils.routeJump(this, '/speedOpt/seo-ant-amp')
                        }}>
                            <div
                                style={{
                                    display: 'flex',
                                    flexGrow: 1,
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    paddingLeft: window.innerWidth < 450 ? '0.3rem' : '1rem',
                                    paddingRight: window.innerWidth < 450 ? '0.3rem' : '1rem',
                                }}
                            >
                                <div className='fullscreen_top_amp'>
                                    {window.innerWidth < 450 ? null : <Text variant="headingMd" as="p">{t("Homepage")}</Text>}
                                    <Badge>{t("Unpublished")}</Badge>
                                    <div className="custome_switch">
                                        <Switch disabled={true} onChange={() => { }} checked={false} height={20} width={32} uncheckedIcon={true} checkedIcon={true} onColor="#303030" offColor="#888888" />
                                        {true && <img className="Loading" src="/imgs/Image/loading.gif" style={{ width: '1.2rem', margin: '0 0.4rem' }} alt="loading" />}
                                    </div>
                                </div>
                                {/* <div className='full_btn_group flex_layout'>
                                    <div className='need_help_amp'>
                                        {issueIcon} <span>{t("Need help")}?</span>
                                    </div>
                                    <Button variant='primary' disabled={true}>{t("Preview")}</Button>
                                </div> */}
                            </div>
                        </FullscreenBar>
                    }
                </div>
                {pageMain}
            </div>
        );
    }
}

export default withRouter(SkeltonLoading);